import { useEffect, useState } from "react";
import { AdminTable } from "./AdminTable";
import { useDispatch, useSelector } from "react-redux";
import { Column } from "devextreme-react/data-grid";
import { openModal } from "../../redux/modal/modalSlice";
import { selectContractList, selectContractListLoading } from "../../redux/contract/selectors";
import { getContractList, updateContract } from "../../redux/contract/thunks";


const initialSortOptions = {
    columna: "contractNumber",
    sortOrderAsc: false

}

function ContractDataManager() {
    const contracts = useSelector(selectContractList);
    const dispatch = useDispatch();
    const loading = useSelector(selectContractListLoading);
    const [sortOptions, setSortOptions] = useState(initialSortOptions)

    useEffect(()=>{
        getListContracts(mapPageInfo(contracts));
    }, [])

    function mapPageInfo(contractsData){
        return {
            pageIndex: contractsData.pageIndex ?? 0,
            pageSize: contractsData.pageSize ?? 10,
            orderByField: contractsData.columna ?? "id",
            orderByAscending: contractsData.sortOrderAsc ?? true
        }
    }
      
    const getListContracts = (pageInfo) => {
        let query = `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`
        if(pageInfo.searchString?.trim().length > 0){
            query = query.concat(`&searchString=${pageInfo.searchString.trim()}`)
        }
        if(pageInfo.orderByField)
            {
                query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`)
            }
        dispatch(getContractList({query}));
    }

    const columnsExceptions = [
        <Column sortIndex={1} key={"contract-data-1"} dataField="contractNumber" width={125} caption="Número" allowEditing={false} allowCreating={false}/>, 
        // <Column key={"contract-data-2"} dataField="plate" width={110} caption="Matrícula" allowEditing={false} allowCreating={false}/>,
        <Column key={"contract-data-2"} dataField="customerCNPJ" width={110} caption="Matrícula" allowEditing={false} allowCreating={false}/>,
        // <Column key={"contract-data-3"} dataField="customerCode" width={110} caption="Código do cliente" allowEditing={false} allowCreating={false}/>, 
        <Column key={"contract-data-4"} dataField="customerName" caption="Nome do cliente" width={250} allowEditing={false} allowCreating={false}/>,
        // <Column key={"contract-data-5"} dataField="insuranceType" dataType={"string"} caption="Tipo de seguro"/>,
        // <Column key={"contract-data-6"} dataField="vipCustomer" calculateSortValue={"vipCustomer"} calculateCellValue={(row)=> row.vipCustomer ? row.vipCustomer : false}  width={90} caption="Cliente VIP"/>,
        // <Column key={"contract-data-7"} dataField="vipService" calculateSortValue={"vipService"} calculateCellValue={(row)=> row.vipService ? row.vipService : false} width={90} caption="Servicio VIP"/>,
        // <Column key={"contract-data-8"} dataField="vipVehicle" calculateSortValue={"vipVehicle"} calculateCellValue={(row)=> row.vipVehicle ? row.vipVehicle : false} width={90} caption="Vehículo VIP"/>,
    ] 
  
    const handleEditClick = (value, closeEditModal) => {
                dispatch(updateContract({body: value, param: value.Id})).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListContracts(mapPageInfo({...contracts, ...sortOptions}));
                        closeEditModal()
                    }    
                })      
    }

    return(
        <div style={{width: "100%"}}>
            <AdminTable 
                sectionTitle={"Contratos"}
                masterTitle={"Contratos"} 
                itemIdField={"id"} 
                itemDescriptionField={"contractNumber"} 
                loading={loading} 
                getData={getListContracts} 
                dataSource={contracts} 
                columnasTabla={columnsExceptions} 
                onEdit={handleEditClick}
                allowCreate={false} 
                sortField={sortOptions}
                setsortField={setSortOptions}
                numElements={[10, 25, 50]}
            />
        </div>
    )
}
export default ContractDataManager;